// 引入布局组件
import LayoutIndex from "@/layout/LayoutIndex.vue";

// 定义路由常量
const supplierRouter = [
  {
    path: "/supplier",
    component: LayoutIndex,
    meta: { title: "客户供应商", icon: "supplier", requireAuth: true },
    name: "supplier",
    redirect: "/home",
    children:[
       {
        path: "/supplier/supplierManagement",
        component: () => import('@/views/supplier/SupplierManagementIndex.vue'),
        name: "supplierManagement",
        meta: { title: "供应商管理", requireAuth: true },
      },
    ]
  },
];

export default supplierRouter;
